(ns frontend.view.settings2.mcp.view
  (:require [common.connection-lifetime :as connection-lifetime]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.actions.tenant :as tenant-actions]
            [frontend.logging :as logging]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.not-found :as not-found]
            [frontend.view.settings2.security.mcp-admin.view :as mcp-admin]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings.configuration/mcp)]])

(defn- connection-lifetime-options
  []
  (->> connection-lifetime/lifetime-options
       (map (fn [{:keys [value key]}]
              {:value value
               :label (loc/tr key)}))))

(defn- save-tenant!
  [tenant-id attribute value on-success! on-error!]
  (tenant-actions/*->update! tenant-id
                             attribute
                             (if (and (string? value)
                                      (cu/blank-value? value))
                               nil
                               value)
                             on-success!
                             on-error!))

(defn- mcp-connection-lifetime-setting
  [tenant-cursor]
  (let [attribute :tenant/mcp-max-connection-lifetime-kw
        old-value (get @tenant-cursor attribute)
        effective-value (or old-value connection-lifetime/default-max-lifetime)
        options (connection-lifetime-options)
        current-option (->> options
                            (filter (fn [{:keys [value]}]
                                      (= value effective-value)))
                            first)]
    [:div
     {:class "flex flex-col gap-3 border border-solid border-base-light-border-paler rounded p-4"}
     [:div {:class "flex flex-col gap-1"}
      [:div {:class "font-semibold text-base"} (loc/tr :settings/mcp-connection-lifetime)]
      [:div {:class "text-sm text-base-light-text-paler"}
       (loc/tr :settings/mcp-connection-lifetime-tooltip)]]
     [:div {:class "max-w-sm"}
      [:div {:class "flex items-center gap-1 mb-1"}
       [:label {:class "font-semibold text-sm leading-none m-0"}
        (loc/tr :settings/mcp-connection-lifetime)]
       [tooltip/view
        {}
        [:i.fal.fa-info-circle.text-base-light-text-paler.cursor-help.text-sm.m-0]
        [:div {:class "max-w-sm text-sm whitespace-pre-line"}
         (loc/tr :settings/mcp-connection-lifetime-tooltip)]]]
      [labelled-input/view
       {:data-type :data.type/keyword
        :value     current-option
        :options   options
        :on-change (fn [new-option]
                     (let [new-value (if (map? new-option)
                                       (:value new-option)
                                       new-option)]
                       (when-not (= new-value old-value)
                         (swap! tenant-cursor assoc attribute new-value)
                         (save-tenant!
                          (:db/id @tenant-cursor)
                          attribute
                          new-value
                          (fn [_]
                            (logging/info "MCP connection lifetime updated"))
                          (fn [_]
                            (swap! tenant-cursor assoc attribute old-value)
                            (logging/error "Failed to update MCP connection lifetime"))))))}]]]))

(defn component
  []
  [:<>
   [zap-toolbar/view nil breadcrumbs nil nil]
   [:div
    {:class "bg-base-light text-base-light-text h-[calc(100vh_-_52px-_37px)] overflow-auto"}
    [:div
     {:class "px-4 py-6 mx-auto w-full max-w-[calc(100vw_-_2rem)] flex flex-col gap-6"}
     [mcp-connection-lifetime-setting session/tenant]
     [mcp-admin/view]]]])

(defmethod routing/render-view :settings/mcp
  [_]
  (if (and (session/is-admin?)
           (session/has-feature-access? :feature/mcp-connector))
    [default-page-layout/view
     {:class-name ""}
     [component]]
    [not-found/not-found-view]))
